import axios from "axios";
import {
  toast
} from "react-toastify";
import {
  push
} from "connected-react-router";

export const VIDEO_GET_ARTICLES_REQUEST = "VIDEO_GET_CATADVS_REQUEST";
export const VIDEO_GET_ARTICLES_SUCCESS = "VIDEO_GET_ARTICLES_SUCCESS";
export const VIDEO_GET_ARTICLES_FAIL = "VIDEO_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: VIDEO_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "dashboard/tv_posts",
      params: params,
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: VIDEO_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: VIDEO_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const VIDEO_GET_CATEGORIES_REQUEST = "VIDEO_GET_CATEGORIES_REQUEST";
export const VIDEO_GET_CATEGORIES_SUCCESS = "VIDEO_GET_CATEGORIES_SUCCESS";
export const VIDEO_GET_CATEGORIES_FAIL = "VIDEO_GET_CATEGORIES_FAIL";
export const getCategories = params => dispatch => {
  dispatch({
    type: VIDEO_GET_CATEGORIES_REQUEST
  });
  axios
    .request({
      url: "categories",
      params: {
        post_type: "tv_post"
      },
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: VIDEO_GET_CATEGORIES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: VIDEO_GET_CATEGORIES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const VIDEO_REMOVE_ARTICLE_REQUEST = "VIDEO_REMOVE_ARTICLE_REQUEST";
export const VIDEO_REMOVE_ARTICLE_SUCCESS = "VIDEO_REMOVE_ARTICLE_SUCCESS";
export const VIDEO_REMOVE_ARTICLE_FAIL = "VIDEO_REMOVE_ARTICLE_FAIL";
export const removeArticle = post_id => dispatch => {
  dispatch({
    type: VIDEO_REMOVE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/post/remove",
      data: {
        post_id
      },
      method: "post"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: VIDEO_REMOVE_ARTICLE_SUCCESS
        });
        toast.success(data.message);
        dispatch(push("/dash/admin/videos"));
      } else {
        dispatch({
          type: VIDEO_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const VIDEO_GET_ARTICLE_REQUEST = "VIDEO_GET_ARTICLE_REQUEST";
export const VIDEO_GET_ARTICLE_SUCCESS = "VIDEO_GET_ARTICLE_SUCCESS";
export const VIDEO_GET_ARTICLE_FAIL = "VIDEO_GET_ARTICLE_FAIL";
export const getArticle = id => dispatch => {
  dispatch({
    type: VIDEO_GET_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/post",
      params: {
        post_id: id
      },
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: VIDEO_GET_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: VIDEO_GET_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const VIDEO_EDIT_ARTICLE_REQUEST = "VIDEO_EDIT_ARTICLE_REQUEST";
export const VIDEO_EDIT_ARTICLE_SUCCESS = "VIDEO_EDIT_ARTICLE_SUCCESS";
export const VIDEO_EDIT_ARTICLE_FAIL = "VIDEO_EDIT_ARTICLE_FAIL";
export const editArticle = ({
  post_id,
  category_ids,
  youtube_link,
  title,
  body,
  status,
  cover_img,
  author_name,
  published_at
}) => dispatch => {
  console.log(category_ids);
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("post_id", post_id);
  params.append("category_ids", category_ids);
  params.append("youtube_link", youtube_link);
  params.append("title", title);
  params.append("body", body);
  params.append("status", status);
  if (cover_img) {
    params.append("cover_image", cover_img);
  }
  params.append("author_name", author_name);
  params.append("published_at", published_at);
  dispatch({
    type: VIDEO_EDIT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/tv_post/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: VIDEO_EDIT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/admin/videos"));
      } else {
        dispatch({
          type: VIDEO_EDIT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const VIDEO_CREATE_ARTICLE_REQUEST = "VIDEO_CREATE_ARTICLE_REQUEST";
export const VIDEO_CREATE_ARTICLE_SUCCESS = "VIDEO_CREATE_ARTICLE_SUCCESS";
export const VIDEO_CREATE_ARTICLE_FAIL = "VIDEO_CREATE_ARTICLE_FAIL";
export const createArticle = ({
  category_ids,
  // youtube_link,
  // title,
  // body,
  // status,
  // cover_img,
  // author_name,
  // published_at
}) => dispatch => {
  // let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  // params.append("category_ids", category_ids);
  // params.append("youtube_link", youtube_link);
  // params.append("title", title);
  // params.append("body", body);
  // params.append("status", status);
  // if (cover_img) {
  //   params.append("cover_image", cover_img);
  // }
  // params.append("author_name", author_name);
  // params.append("published_at", published_at);
  dispatch({
    type: VIDEO_CREATE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/tv_post/create",
      data: {
        category_ids
      },
      method: "POST",
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: VIDEO_CREATE_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        // dispatch(push("/admin/videos"));
        dispatch(push("/dash/admin/videos/" + data.data.id + "/edit"));
      } else {
        dispatch({
          type: VIDEO_CREATE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};